export const usersTab = 'usersTab';
export const newUsersBtn = 'newUsersBtn';
export const showArchivedSwitch = 'showArchivedSwitch';
